import { render, staticRenderFns } from "./OrbitBanner.vue?vue&type=template&id=53a598e9&scoped=true"
import script from "./OrbitBanner.vue?vue&type=script&lang=ts"
export * from "./OrbitBanner.vue?vue&type=script&lang=ts"
import style0 from "./OrbitBanner.vue?vue&type=style&index=0&id=53a598e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a598e9",
  null
  
)

export default component.exports